import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "@fontsource/space-grotesk/400.css";
import "@fontsource/space-grotesk/500.css";
import "@fontsource/space-grotesk/600.css";
import "@fontsource/space-grotesk/700.css";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import App from "./App.tsx";
import { initSentry } from "./lib/sentry";
import { installChunkErrorListeners } from "./lib/chunk-errors";
import "./i18n";
import "./index.css";

// Must run before React renders so early errors are captured.
initSentry();
// Report dynamic-import (chunk) failures that escape React boundaries.
installChunkErrorListeners();


createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
